import { Routes } from "@angular/router";
import { LayoutPrivateComponent } from "./layout/layout-private/layout-private.component";
import { validateTransferGuard } from "./guards/validate-transfer.guard";
import { authGuardActivate } from "./guards/auth.guard";

export const routes: Routes = [
  {
    path: "painel",
    component: LayoutPrivateComponent,
    canActivate: [validateTransferGuard, authGuardActivate],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./views/private/private.routes").then((r) => r.privateRoutes),
      },
    ],
  },
  {
    path: "",
    loadChildren: () =>
      import("./views/public/public.routes").then((r) => r.publicRoutes),
  },
  { path: "**", redirectTo: "/login" },
];
